import { useEffect, useState } from "react";
import "./NavBar.css";
import { Link, useLocation } from "react-router-dom";
import OutsideClickHandler from "react-outside-click-handler";
import { RiMenu3Fill, RiCloseFill } from "react-icons/ri";
import Logo from "../../assets/Belsoft Logo Icon 1.png";
import secondLogo from "../../assets/Belsoft Logo White Icon PNG 1.png";

const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const handleScroll = () => {
    const offset = window.scrollY;
    setScrolled(offset > 400);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const isHomePage = location.pathname === "/";

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const [menuOpened, setMenuOpened] = useState(false);

  const getMenuStyle = (isOpen) => {
    if (document.documentElement.clientWidth <= 768) {
      return { top: !isOpen && "-500px" };
    }
    return {};
  };

  return (
    <nav
      className={`navbar 
        ${scrolled ? "scrolled" : ""} 
        ${isHomePage ? "home-page" : ""}`}
      aria-label="Main navigation"
    >
      <div className="container">
        <div className="logo">
          <div className="navbar-logo">
            <Link to="/" onClick={scrollToTop}>
              <img src={Logo} alt="Belsoft Logo" />
              <img src={secondLogo} alt="" aria-hidden="true" />
            </Link>
          </div>
        </div>

        <div className="mobile-menu">
          <button
            type="button"
            className="menu-toggle"
            onClick={() => setMenuOpened((prev) => !prev)}
            aria-expanded={menuOpened}
            aria-controls="main-menu"
            aria-label={menuOpened ? "Close menu" : "Open menu"}
          >
            {menuOpened ? <RiCloseFill /> : <RiMenu3Fill />}
          </button>
        </div>

        <OutsideClickHandler
          onOutsideClick={() => {
            setMenuOpened(false);
          }}
        >
          <div id="main-menu" className="menu" style={getMenuStyle(menuOpened)}>
            <div className="menu-bg-overlay" />
            <ul className="menu-list-container">
              <li className="menu-list">
                <Link
                  to="/"
                  onClick={() => {
                    setMenuOpened(false);
                    scrollToTop();
                  }}
                >
                  Home
                </Link>
              </li>
              <li className="menu-list">
                <Link
                  to="/our-services"
                  onClick={() => {
                    setMenuOpened(false);
                    scrollToTop();
                  }}
                >
                  Services
                </Link>
              </li>
              <li className="menu-list">
                <Link
                  to="/technologies"
                  onClick={() => {
                    setMenuOpened(false);
                    scrollToTop();
                  }}
                >
                  Technologies
                </Link>
              </li>
              <li className="menu-list">
                <a
                  href="https://www.belsoftacademy.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setMenuOpened(false)}
                >
                  BelSoft Academy
                </a>
              </li>
              <li className="menu-list">
                <Link
                  to="/case-studies"
                  onClick={() => {
                    setMenuOpened(false);
                    scrollToTop();
                  }}
                >
                  Our Work
                </Link>
              </li>
              <li className="menu-list">
                <Link
                  to="/hire-us"
                  onClick={() => {
                    setMenuOpened(false);
                    scrollToTop();
                  }}
                >
                  Hire Us
                </Link>
              </li>
              <li className="menu-list">
                <Link
                  to="/support"
                  onClick={() => {
                    setMenuOpened(false);
                    scrollToTop();
                  }}
                >
                  Support
                </Link>
              </li>
              <li className="menu-list">
                <Link
                  to="/blog"
                  onClick={() => {
                    setMenuOpened(false);
                    scrollToTop();
                  }}
                >
                  Blog
                </Link>
              </li>
            </ul>
          </div>
        </OutsideClickHandler>
      </div>
    </nav>
  );
};

export default NavBar;
